// Generated from src/img/svg/airport.svg

export const Airport = (props) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g data-name="Ebene 2">
        <g data-name="Ebene 1">
          <path d="M0 0h24v24H0Z" style={{ fill: "none" }} />
          <path
            d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0m7.3 5.6c0 .1 0 .1-.1.1l-.2.7h-.1A2.9 2.9 0 0 1 18 8l-2.9 2.9 1.8 7.7a1.2 1.2 0 0 1-.2 1l-.9.8-3.5-6.6-3.5 3.5.2 1.8a.5.5 0 0 1-.2.6l-.7.7-1.3-3L3.7 16l.7-.7a.7.7 0 0 1 .6-.2l1.9.3 3.5-3.5-6.7-3.5.9-.9a.8.8 0 0 1 .9-.3L13.2 9l2.9-2.9a3.8 3.8 0 0 1 1.5-.9h.2l.6-.2a.1.1 0 0 0 .1-.1h.1a.7.7 0 0 1 .7.7"
            style={{ fill: "#353535" }}
          />
        </g>
      </g>
    </svg>
  );
};
